import { Route } from 'react-router-dom';

import { SettingsIntegrationsWebhooksView } from './settingsIntegrationsWebhooks.view';
import { SettingsIntegrationsWebhooksCreateView } from './views/create';
import { SettingsIntegrationsWebhooksEditView } from './views/edit';
import { SettingsIntegrationsWebhooksEventView } from './views/event';
import { SettingsIntegrationsWebhooksEventListView } from './views/eventList';

export const settingsIntegrationsWebhooksRoutes = (
  <Route path="webhooks">
    <Route path="" element={<SettingsIntegrationsWebhooksView />} />
    <Route path="create" element={<SettingsIntegrationsWebhooksCreateView />} />
    <Route path="edit/:id" element={<SettingsIntegrationsWebhooksEditView />} />
    <Route
      path=":id/:event"
      element={<SettingsIntegrationsWebhooksEventView />}
    />
    <Route path=":id" element={<SettingsIntegrationsWebhooksEventListView />} />
  </Route>
);
